// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName
//
// NOTE: Admin-only controllers (sortable, sidebar) are registered in
// ../admin.js so they don't ship in the public bundle. Remove them here
// again if stimulus:manifest:update re-adds them.

import { application } from "./application"

import HeaderController from "./header_controller"
application.register("header", HeaderController)

import ServiceListController from "./service_list_controller"
application.register("service-list", ServiceListController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)

import PageFilterController from "./page_filter_controller"
application.register("page-filter", PageFilterController)

import ReceptionController from "./reception_controller"
application.register("reception", ReceptionController)
